'use strict';

const cognitoUsernameForLicense = require('./cognito-username-for-license');
module.exports = function CognitoApi(goldApi, cognitoIdentityShim) {
	let pendingUserAction;
	const self = this,
		execAuthenticatedMethod = function (url, params) {
			return cognitoIdentityShim.cognitoUserAndSession().then(function (userAndSession) {
				const token = cognitoIdentityShim.getIdentityToken(userAndSession.session);
				return goldApi.exec(url, params || {}, {'Authorization': token});
			});
		};

	self.getUserActions = function () {
		return execAuthenticatedMethod('cognito/allowed_actions');
	};
	self.globalSignOut = () => {
		return cognitoIdentityShim.cognitoUserAndSession()
		.then((userAndSession) => {
			return new Promise((resolve, reject) => {
				userAndSession.cognitoUser.globalSignOut({
					onSuccess: resolve,
					onFailure: reject
				});
			});
		})
		.then(() => false);
	};

	self.signInWithLicense = function (license) {
		if (!license) {
			return Promise.reject('invalid-args');
		}
		const username = cognitoUsernameForLicense(license);
		return cognitoIdentityShim.authenticateUsingCustomFlow(username)
		.catch((reason) => {
			if (reason === 'no-user') {
				return goldApi.exec('incognito/create_cognito-user', {license: license})
				.then(() => cognitoIdentityShim.authenticateUsingCustomFlow(license.account));
			}
			throw reason;
		})
		.then((response) => {
			if (!response || !response.action) {
				throw 'network-error';
			}
			if (response.action === 'customChallengeResponseRequired') {
				return cognitoIdentityShim.respondToCustomChallenge(response, JSON.stringify(license));
			}
			throw response.action;
		});
	};
	self.userProfile = function () {
		const cognitoProfile = {};
		return cognitoIdentityShim.cognitoUserAndSession()
		.then(userAndSession => {
			cognitoProfile.identityToken = cognitoIdentityShim.getIdentityToken(userAndSession.session);
			cognitoProfile.credentials = cognitoIdentityShim.createIdentityCredentials(userAndSession.session);
			return cognitoIdentityShim.getUserAttributes(userAndSession.cognitoUser);
		})
		.then(userAttributes => {
			if (!userAttributes['custom:mm-license']) {
				throw 'no-license';
			}
			cognitoProfile.userAttributes = userAttributes;
			return cognitoProfile;
		});

	};

	self.signIn = function (username, password) {
		pendingUserAction = false;
		return cognitoIdentityShim.authenticate(username, password)
		.then((result) => {
			if (result && result.action) {
				pendingUserAction = result;
				throw 'new-password-required';
			}
			return result;
		});
	};
	self.signOut = function () {
		return cognitoIdentityShim.cognitoUserAndSession()
		.then(userAndSession => {
			userAndSession.cognitoUser.signOut();
		})
		.catch(reason => {
			if (!['not-authenticated', 'no-user'].includes(reason)) {
				throw reason;
			}
			return false;
		});
	};

	self.changePassword = function (oldPassword, newPassword) {
		return cognitoIdentityShim.changePassword(oldPassword, newPassword);
	};
	self.requestPasswordReset = function (username) {
		return cognitoIdentityShim.requestPasswordReset(username)
		.then(function (response) {
			pendingUserAction = {
				action: 'completePasswordReset',
				user: response.cognitoUser
			};
			const result = response && response.result;
			return {
				maskedEmail: result && result.CodeDeliveryDetails && result.CodeDeliveryDetails.Destination
			};
		})
		.catch(function (reason) {
			if (reason === 'no-password') {
				return goldApi.exec('incognito/send_temporary_password', {username: username})
				.then((response) => {
					pendingUserAction = {
						action: 'setInitialPassword',
						user: username
					};
					return {
						maskedEmail: response && response.maskedEmail
					};
				});
			}
			throw reason;
		});

	};
	self.completePendingUserAction = function (actionResponse, optionalActionResponse) {
		if (!pendingUserAction || !pendingUserAction.action || !pendingUserAction.user) {
			return Promise.reject('requestPasswordReset');
		}
		return cognitoIdentityShim[pendingUserAction.action](pendingUserAction.user, actionResponse, optionalActionResponse)
		.then((response) => {
			pendingUserAction = false;
			return response;
		});
	};
};
